import { useState } from 'react';
import { Link } from 'react-router-dom';

const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/category-913-T-Shirts.html' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/category-914-Jackets.html' },
  { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/category-916-Headwear.html' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/category-917-Sets.html' },
  { name: 'Underwear/Underpants', url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/category-919-Jersey.html' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/category-920-Accessories.html' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/category-921-Bags.html' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Bags.html' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Bags.html' },
  { name: 'OtherStuff', url: 'https://kaspreadsheet.com/search-924/name/Bags.html' },
];

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    setSubmitStatus('loading');
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      await fetch('https://readdy.ai/api/form/d8pvcb5e8ise6dlc87qg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });

      setSubmitStatus('success');
      setEmail('');
      setTimeout(() => setSubmitStatus('idle'), 4000);
    } catch {
      setSubmitStatus('error');
      setTimeout(() => setSubmitStatus('idle'), 4000);
    }
  };

  return (
    <footer className="bg-foreground-950 rounded-2xl mx-4 md:mx-8 mb-4 md:mb-8 overflow-hidden">
      <div className="px-6 md:px-12 pt-12 md:pt-16 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-flex items-center gap-2 mb-6 cursor-pointer">
              <div className="w-8 h-8 rounded-lg bg-primary-400 flex items-center justify-center">
                <i className="ri-file-list-3-line text-white text-lg"></i>
              </div>
              <span className="text-lg font-semibold text-background-50 font-heading">
                Sugargoo<span className="text-primary-400">Spreadsheet</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-200/60 leading-relaxed mb-6 max-w-xs">
              The most comprehensive Sugargoo Spreadsheet resource. Updated daily with verified links, shopping guides, and safe shopping tips.
            </p>
            <div className="flex items-center gap-3">
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full bg-foreground-800/50 flex items-center justify-center text-foreground-200 hover:text-background-50 hover:bg-primary-500 transition-all cursor-pointer" aria-label="Visit main site">
                <i className="ri-external-link-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-5">Categories</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-200/50 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-5">Resources</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-200/50 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/articles/what-is-sugargoo-spreadsheet" className="text-sm text-foreground-200/50 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                  Beginner Guide
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-200/50 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                  Visit Main Store
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-5">Newsletter</h4>
            <p className="text-sm text-foreground-200/50 mb-4 leading-relaxed">
              Subscribe for updated spreadsheet links and new finds.
            </p>
            <form onSubmit={handleSubscribe} data-readdy-form="" className="flex gap-0">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                required
                className="flex-1 px-4 py-2.5 bg-foreground-800/30 border border-foreground-700/30 rounded-l-full text-sm text-background-50 placeholder:text-foreground-400/40 outline-none focus:border-primary-400/50 transition-colors"
              />
              <button
                type="submit"
                disabled={submitStatus === 'loading'}
                className="w-11 h-[42px] bg-primary-500 hover:bg-primary-400 rounded-r-full flex items-center justify-center transition-colors cursor-pointer disabled:opacity-60"
              >
                {submitStatus === 'loading' ? (
                  <i className="ri-loader-4-line text-white text-sm animate-spin"></i>
                ) : (
                  <i className="ri-arrow-right-line text-white text-sm"></i>
                )}
              </button>
            </form>
            {submitStatus === 'success' && (
              <p className="text-xs text-accent-400 mt-2">Subscribed successfully! Thank you.</p>
            )}
            {submitStatus === 'error' && (
              <p className="text-xs text-red-400 mt-2">Something went wrong. Please try again.</p>
            )}
          </div>
        </div>

        <div className="mt-12 md:mt-16 pt-6 border-t border-foreground-800/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-200/30">
            &copy; {new Date().getFullYear()} SugargooSpreadsheet.run. This website is an independent informational resource and is not affiliated with Sugargoo or any listed brands.
          </p>
          <p className="text-xs text-foreground-200/30">
            All external links open with <strong>target=&quot;_blank&quot; rel=&quot;noopener nofollow&quot;</strong>.
          </p>
        </div>
      </div>

      <div className="px-6 md:px-12 pb-8 md:pb-12">
        <div className="text-[clamp(2rem,8vw,7rem)] font-black text-foreground-200/[0.03] font-heading leading-none select-none whitespace-nowrap overflow-hidden">
          SUGARGOO SPREADSHEET
        </div>
      </div>
    </footer>
  );
}